import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { ContentLayout } from '../../components/layouts/ContentLayout';
import { useAuditTrailFilterQuery } from '../../graphql/hooks/useAuditTrailQuery';
import { useAuditTrailFilter } from '../../hooks/useAuditTrailFilter';
import { AuditTrailFilterControls } from './AuditTrailFilterControls';
import { AuditTrailTable } from './AuditTrailTable';

export const AuditTrail = () => {
  const filter = useAuditTrailFilter();
  const { isLoading, error, entries, pagination, refetch } = useAuditTrailFilterQuery(filter);

  return (
    <ContentLayout
      headerContent={
        <ChakraV3.HStack align='start'>
          <ChakraV3.Heading size='3xl' fontWeight='bold'>
            Audit Trail
          </ChakraV3.Heading>
        </ChakraV3.HStack>
      }
    >
      <ChakraV3.Stack gap={4} px={6}>
        <AuditTrailFilterControls filter={filter} />
        <AuditTrailTable
          entries={entries}
          error={error}
          isLoading={isLoading}
          pagination={pagination}
          refetch={refetch}
        />
      </ChakraV3.Stack>
    </ContentLayout>
  );
};
